import React from "react";

export const ContentfulContext = React.createContext({
  entries: {},
  assets: {},
});
